<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded && this.items.length > 0" :caption="this.isLoaded ? 'Показать ' + this.topCount : 'Показать все'" :expandable="items.length > topCount">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        Контакты ({{items.length}})
        <v-layout row wrap align-left>
          <template v-for="item in topItems">
            <v-flex>
              <b><component :is="createContactTitle(item)"></component></b>
              <v-component v-show="item.clientIndividualId" :is="renderContactButton('Открыть контакт физического лица', openContact, item)" />

              <v-flex pl-2> 
                <component :is="createContactContent(item)"></component>
              </v-flex>
            </v-flex>
            <!-- <component :is="createContactContent(item)"></component> -->
          </template>
       </v-layout>
      </div>  
    </v-panel-title>
    <v-card-text v-show="isLoaded && items.length > 0" class="pt-0">
      <template v-for="item in lastItems">
        <v-flex>
          <b><component :is="createContactTitle(item)"></component></b>
          <v-component v-show="item.clientIndividualId" :is="renderContactButton('Открыть контакт физического лица', openContact, item)" />
          <v-flex pl-2> 
            <component :is="createContactContent(item)"></component>
          </v-flex>
        </v-flex>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import vPanelTitle from './PanelTitle'
  import people from '../people/index.js'

  export default {
    name: 'v-records-panel',
    components: {vPanelTitle},
    data: () => ({
      id: null,
      isLoaded: false,
      isLoading: false,
      items: [],
      topCount: 1
    }),
    props: {
      fillHeight: {
        type: Boolean,
        default: false
      },
      refCode: {
        type: String,
        default: false
      }
    },
    mounted () {
      if (this.refCode) {
        this.id = this.refCode
        this.fetchItems()
      }
    },
    watch: {
      ogrn: function (newVal, oldVal) { // watch it
        this.id = newVal
        if (this.id) {
          this.fetchItems()
        }
      }
    },
    computed: {
      ...mapGetters({
        renderContactButton: 'renderContactButton'
      }),
      topItems () {
        return this.orderedItems.slice(0, this.topCount)
      },
      lastItems () {
        return this.orderedItems.slice(this.topCount)
      },
      orderedItems () {
        return people.sortContactsByCompany(this.items)
      }
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
      },
      fetchItems () {
        if (this.id && !this.isLoading) {
          this.items = []
          this.isLoading = true
          this.$store.dispatch('getCompanyContacts', this.id).then((data) => {
            this.isLoading = false
            this.items = data
          })
        }
      },
      createContactTitle (item) {
        let strategy = people.createStrategy(this, 'CONTACT')
        strategy.setParentProps({refCode: this.id})
        if (strategy && strategy.viewTitleComp) {
          return strategy.viewTitleComp(strategy.createModelFromData(item))
        }
        return formats.createComp('<span>Новый тип документа</span>')
      },
      createContactContent (item) {
        let strategy = people.createStrategy(this, 'CONTACT')
        strategy.setParentProps({refCode: this.id})
        if (item && strategy && strategy.viewContentComp) {
          return strategy.viewContentComp(strategy.createModelFromData(item))
        }
        return formats.createComp('<span></span>')
      },
      openContact (item) {
        people.open(item.clientIndividualId)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// ContactsPanel.vue?4684b33a